import React, { useEffect, useState } from "react";
import {
  Container,
  PriceContainer,
  TokenBundle,
  TokenInformation,
  TokenPrice,
  Tokens,
  DiscountInfo,
} from "./styles";
import { bundleMap } from "./helper";
import TextView from "../../../TextView";
import { getTokenBundles } from "../../../../services/api";
import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { setSelectedBundle } from "../../../../redux/reducers/aiWheels";

export const TokenUpgradeContent = () => {

  const dispatch = useDispatch();

  const [tokenBundles, setTokenBundles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTokenBundle, setSelectedTokenBundle] = useState(null);

  const handleSelect = (bundle) => {
    setSelectedTokenBundle(bundle);
    dispatch(setSelectedBundle(bundle));
  };

  const fetchTokenBundles = async () => {
    try{
      const response = await getTokenBundles();
      console.log("response", response);
      if(response && response?.data?.data?.length){
        setTokenBundles(response.data.data);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsLoading(false);
      console.error("Error fetching token bundles:", error);
    }
  }

  useEffect(() => {
    fetchTokenBundles()
  }, [])
  return (
    <Container>
      {isLoading && 
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
          <CircularProgress />
        </div>
      }

      {!isLoading && tokenBundles.map((bundle) => (
        <TokenBundle 
          key={bundle.id}
          onClick={() => handleSelect(bundle)}
          isSelected={selectedTokenBundle?.id === bundle.id}
        >
          <img
            src={bundleMap[bundle.name]}
            alt={`Token Bundle ${bundle.id}`}
            width={48}
            height={48}
          />
          <TokenInformation>
            <TextView>
              <Tokens>{bundle.token_amount}</Tokens>
              Tokens
            </TextView>
            <PriceContainer>
              <TokenPrice>${bundle.is_discounted ? bundle.discounted_price : bundle.price}</TokenPrice>
              {bundle.is_discounted && <DiscountInfo>{Number(bundle.discount) * 100}% Off</DiscountInfo>}
            </PriceContainer>
          </TokenInformation>
        </TokenBundle>
      ))}
    </Container>
  );
};
